<script>
	export default {
		name: 'PageExecuter',
		methods: {
			getPageContents(key) {
				const self_ = this;
				const contents_ = self_.getContentsState('page')
				if(self_.isFalse(contents_)) { return {} }
				return contents_[key]
			},
			getPageInits(key) {
				const self_ = this;
				const inits_ = self_.getInitsState('page')
				if(self_.isFalse(inits_)) { return {} }
				return inits_[key]
			},
			setPageContents(key, value) {
				const self_ = this;
				self_.setContentsState('page', key, value)
			},
			setPageInits(key, value) {
				const self_ = this;
				self_.setInitsState('page', key, value)
			},
			initializePage(pageName, pageType) {
				const self_ = this;
				const router_ = self_.$router;

				const dataTypes_ = ['contents', 'inits']

				let promiseArray_ = []

				dataTypes_.forEach(dataType => {
					promiseArray_.push(self_.$_pgExec_setPageData(pageName, pageType, dataType))
				})

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return Promise.all(promiseArray_)
					}).then(() => {
						// initialized
						let initialized_ = self_.getPageState('isInitialized')
						initialized_[pageName] = true
						self_.setPageState('isInitialized', initialized_)
						// execute beforeMountPage of lifecycle
						self_.beforeMountPage(pageName)

						resolve()
					}).then(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: initializePage(' + pageName + ', ' + pageType +') -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			$_pgExec_setPageData(pageName, pageType, dataType) {
				const self_ = this;

				const default_ = self_.$_pgExec_getDefault(pageName, pageType, dataType)

				let result_ = {}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreSubCollection(dataType, 'page', pageName)
					}).then(result => {
						if(self_.isEmpty(result)) {
							result_ = default_
						} else {
							result_ = self_.$_pgExec_mergeDefault(default_, result)
						}

						self_.$_pgExec_setPageState(dataType, pageName, result_)

						resolve()
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: setPageData(' + pageName + ', ' + pageType + ', ' + dataType + ') -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			$_pgExec_getDefault(pageName, pageType, dataType) {
				const self_ = this;
				// for dummy page
				let name_ = null;
				if(pageName == 'dummy') { name_ = '_' }
				else { name_ = pageName }
				// for non index page
				let type_ = null;
				if(self_.isFalse(pageType)) { type_ = 'default_' }
				else { type_ = pageType + '_' }

				const nameState_ = self_.$_pgExec_getPageState(dataType, name_)
				const typeState_ = self_.$_pgExec_getPageState(dataType, type_)
				const defaultState_ = self_.$_pgExec_getPageState(dataType, 'default_')

				if(self_.isObject(nameState_)) { return nameState_; }
				else if(self_.isObject(typeState_)) { return typeState_; }
				else { return defaultState_ }
			},
			$_pgExec_mergeDefault(defaultObj, resultObj) {
				Object.keys(resultObj).forEach(key => {
					if(defaultObj[key]) {
						Object.keys(resultObj[key]).forEach(subKey => {
							defaultObj[key][subKey] = resultObj[key][subKey]
						})
					} else {
						defaultObj[key] = resultObj[key]
					}
				})

				return defaultObj
			},
			$_pgExec_getPageState(dataType, key) {
				const self_ = this;
				
				if(dataType == 'contents') { return self_.getPageContents(key) }
				if(dataType == 'inits') { return self_.getPageInits(key) }
			},
			$_pgExec_setPageState(dataType, key, value) {
				const self_ = this;
				
				if(dataType == 'contents') { self_.setPageContents(key, value) }
				if(dataType == 'inits') { self_.setPageInits(key, value) }
			}
		}
	}
</script>